import React from 'react';
import { IonApp, IonRouterOutlet } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Switch, Redirect } from 'react-router-dom';
import LoginPage from './pages/auth/LoginPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import ResetPasswordPage from './pages/auth/ResetPasswordPage';
import ConsentPage from './pages/consent/ConsentPage';
import AppShell from './components/layout/AppShell';
import ErrorBoundary from './components/shared/ErrorBoundary';
import { useAuthStore } from './store/authStore';

const App: React.FC = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <ErrorBoundary>
    <IonApp>
      <IonReactRouter>
        <Switch>
          {/* Public route — accessible regardless of auth state */}
          <Route exact path="/consent/:token" component={ConsentPage} />

          {/* Auth-gated routing */}
          <Route>
            {!isAuthenticated ? (
              <IonRouterOutlet>
                <Route exact path="/login" component={LoginPage} />
                <Route exact path="/forgot-password" component={ForgotPasswordPage} />
                <Route exact path="/reset-password" component={ResetPasswordPage} />
                <Route>
                  <Redirect to="/login" />
                </Route>
              </IonRouterOutlet>
            ) : (
              <AppShell />
            )}
          </Route>
        </Switch>
      </IonReactRouter>
    </IonApp>
    </ErrorBoundary>
  );
};

export default App;
